import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import CurrencyFormat from 'react-currency-format';
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

// import api
import { getStakeHistory, getStakingCurrency } from "../../api/staking";

// import lib
import { dateTimeFormat } from "../../lib/dateTimeHelper";
import { toFixed, truncateDecimals } from "../../lib/roundOf"


const StakingHistory = () => {

    const { t, i18n } = useTranslation()


    //REDUX
    const priceConversion = useSelector((state) => state.priceConversion);

    // state
    const [data, setData] = useState([]);
    const [count, setCount] = useState(0);
    const [pageDoc, setPageDoc] = useState({
        page: 1, limit: 20, coin: 'all',
        type: 'interest'
    });
    const [currencyData, setCurrencyData] = useState([])
    const { page, limit, coin, type } = pageDoc;

    //function
    const handleChange = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        let filterData = {
            ...pageDoc,
            [name]: value, 'page': 1,
            'limit': 20
        }

        setPageDoc(filterData)
        getData(filterData)
    }

    const getData = async (reqData) => {
        try {
            const { status, result } = await getStakeHistory(reqData);
            if (status) {
                let newRecord = [];
                let cumulativeInterest = 0;
                let previousTotalAmount = 0;
                const historyData = result?.data && result?.data?.length > 0 ? [...result.data].reverse() : [];

                historyData.map((item) => {
                    const interestValue = parseFloat(item?.amount || 0);
                    cumulativeInterest += interestValue;
                    newRecord.push({
                        "date": item.createdAt,
                        "coin": item.coin,
                        "amount": truncateDecimals(item?.stakeAmount, item.decimals),
                        "stakeBaseAmount": truncateDecimals(item?.stakeBaseAmount || item?.stakeAmount, item.decimals),
                        "totalAmount": truncateDecimals(item?.openingAmount || 0, item.decimals),
                        "APY": item.APY + " %",
                        // "interestEarned": item.amount ? truncateDecimals(item?.amount, (type == "restake" ? 8 : item.decimals)) : '0',
                        // "totalEarnedAmount": item.amount ? truncateDecimals(item?.amount, (type == "restake" ? 8 : item.decimals)) : '0',
                        "interestEarned": item.amount || "0",
                        "totalEarnedAmount": item.amount || "0",
                        "cumulativeInterest": truncateDecimals(cumulativeInterest, 8),
                        decimals: item.decimals,
                        "type": item.type,
                    })
                })
                setData(newRecord.reverse());
                setCount(result?.count);
            }
        } catch (err) {
            console.log(err, 'errro')
        }
    };


    const fetchCurrency = async () => {
        try {
            const { status, result } = await getStakingCurrency();
            if (status) {
                setCurrencyData(result)
            }
        } catch (err) {
            console.log(err, 'error')
        }
    }




    useEffect(() => {
        let reqData = {
            page, limit, coin, type
        }
        getData(reqData)
        fetchCurrency()
    }, [page, limit, coin, type])


    // StakingHistory History Table Data
    const columns = [
        {
            name: t("DATE"),
            selector: (row) => row.date,
            cell: (record) => `${dateTimeFormat(record.date)}`,
        },
        {
            name: t("COIN"),
            cell: (record) => `${record.coin}`,
        },
        ...(type === 'restake'
            ? [{
                name: 'Stake Amount',
                selector: (row) => row.stakeBaseAmount,
                cell: (record) => {
                    return (
                        <CurrencyFormat displayType={'text'} thousandSeparator={true} value={record?.stakeBaseAmount} />
                    )
                },
            },
            {
                name: 'Total Amount',
                selector: (row) => row.totalAmount,
                cell: (record) => {
                    return (
                        <CurrencyFormat displayType={'text'} thousandSeparator={true} value={record?.totalAmount} />
                    )
                },
            }]
            : [{
                name: t("AMOUNT"),
                selector: (row) => row.amount,
                cell: (record) => {
                    return (
                        <CurrencyFormat displayType={'text'} thousandSeparator={true} value={record?.amount} />
                    )
                },
            }]),
        {
            name: t("APY"),
            cell: (record) => `${record.APY}`,
        },
        ...(type === 'restake'
            ? [{
                name: 'Total Earned Amount',
                cell: (record) => {
                    return (
                        <CurrencyFormat displayType={'text'} thousandSeparator={true} value={truncateDecimals(record?.totalEarnedAmount, 8)} />
                    )
                },
            }]
            : [{
                name: t("INTEREST_EARNED"),
                cell: (record) => {
                    return (
                        <CurrencyFormat displayType={'text'} thousandSeparator={true} value={truncateDecimals(record?.interestEarned, record.decimals)} />
                    )
                },
            }]),
        ...(type === 'restake'
            ? [{
                name: 'Cumulative Interest',
                cell: (record) => {
                    return (
                        <CurrencyFormat displayType={'text'} thousandSeparator={true} value={record?.cumulativeInterest} />
                    )
                },
            }]
            : []),
        {
            name: t("INTEREST_IN"),
            cell: (record) => {
                let PriceCnv = priceConversion.find(
                    (el) =>
                        el.baseSymbol == record.coin && el.convertSymbol == "USD"
                );
                let marketPrice = 1
                if (PriceCnv) marketPrice = PriceCnv.convertPrice
                // let interestearn = toFixed(parseFloat((type === 'restake' ? record?.totalEarnedAmount : record?.interestEarned) || 0) * marketPrice, 2)
                let interestearn = parseFloat((type === 'restake' ? record?.totalEarnedAmount : record?.interestEarned) || 0) * marketPrice
                interestearn = truncateDecimals(interestearn, 2)
                return (
                    <CurrencyFormat displayType={'text'} thousandSeparator={true} value={interestearn} />
                )
            },
        },
        {
            name: t("STAKE_TYPE"),
            selector: (row) => row.type,
            cell: (record) => {
                let data = (record.type == "flexible" || record.type == "Flexible")  ? t("FLEXIBLE") : t("FIXED")
                return (
                    <>{data}</>
                )
            }
        },
    ];

    const customPaginationOptions = {
        rowsPerPageText: t('ROWS_PER_PAGE'),
        rangeSeparatorText: t('OF'),
    };

    return (
        <>
            <div className="mt-6">
                <h2 className="text-[#395645] font-semibold text-[20px] mb-2">{t("STAKING_HISTORY")}</h2>
            </div>
            <div className="rounded-sm outline outline-1 outline-offset-[-1px] outline-[#6B7280]/25 p-4">
                <div class="input-group">
                    <select value={coin}
                        name="coin"
                        onChange={handleChange} className="form-select primary_asset_select">
                        <option value={'all'}>{t("ALL")}</option>
                        {
                            currencyData && currencyData.length > 0 && currencyData.map((item, key) => {
                                return (
                                    <option value={item.coin} key={key}>
                                        {item.coin}
                                    </option>
                                )
                            })
                        }
                    </select>
                    {" "}
                    <select
                        value={type}
                        name="type"
                        onChange={handleChange}
                        className="form-select primary_asset_select">
                        <option value={'interest'}>{t("INTEREST")} </option>
                        {/* <option value={'restake'}>{t("AUTO_RESTAKE")}</option> */}
                        <option value={'subscription'}>{t("SUBSCRIPTION")} </option>
                    </select>
                </div>

                <div className="primary_datatable">
                    <DataTable
                        columns={columns}
                        data={data}
                        pagination
                        paginationServer
                        paginationTotalRows={count}
                        paginationPerPage={limit}
                        paginationRowsPerPageOptions={[20, 30, 40, 50]}
                        onChangePage={(page) =>
                            setPageDoc({ ...pageDoc, ...{ page: page } })
                        }
                        onChangeRowsPerPage={(limit) =>
                            setPageDoc({ ...pageDoc, ...{ page: 1, limit: limit } })
                        }
                        noDataComponent={<div style={{ padding: "20px" }}>{t("THERE_NO_RECORD")}</div>}
                        paginationComponentOptions={customPaginationOptions}
                    />
                </div>
            </div>
        </>
    );
};

export default StakingHistory;
